import React from 'react';
import { useSelector } from 'react-redux';

import { selectPrimarySubscription } from '../../../../auth/AuthSelectors';
import { LICENSE_COMPARISON_PAGE_ROUTE } from '../../../../common/SiteConstants/EnterpriseSiteConstants';
import SiteConstants from '../../../../common/SiteConstants/SiteConstants';
import { selectDetailsIsEnterpriseMember } from '../../../selectors/detailsSelectors';

import './MemberDownloadCtaDisclaimer.less';

interface Props {
  needsToUpgrade?: boolean;
}

const MemberDownloadCtaDisclaimer = ({ needsToUpgrade }: Props) => {
  const primarySubscription = useSelector(selectPrimarySubscription);

  const licenseName = primarySubscription?.licenseName;

  if (needsToUpgrade || !licenseName) {
    return null;
  }

  if (licenseName === SiteConstants.getBusinessLicenseName()) {
    return (
      <div className="memberDownloadCtaDisclaimer">
        <div className="memberDownloadCtaDisclaimer-wrapper">
          <p>
            You&apos;re currently on our <strong>Business License</strong>
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="memberDownloadCtaDisclaimer">
      <div className="memberDownloadCtaDisclaimer-wrapper">
        <p>
          You&apos;re currently on our{' '}
          <strong>{SiteConstants.getIndividualLicenseName()} License</strong>
        </p>
        <p>
          Upgrade today to our&nbsp;
          <a
            className="memberDownloadCtaDisclaimer-enterpriseLink"
            href={LICENSE_COMPARISON_PAGE_ROUTE}
            target="_blank"
          >
            {SiteConstants.getBusinessLicenseName()} License
          </a>
          &nbsp;for:
        </p>
        <ul className="memberDownloadCtaDisclaimer-licenseBullets">
          <li>Up to $1M in indemnification</li>
          <li>License to a company or business</li>
        </ul>
      </div>
    </div>
  );
};

export default MemberDownloadCtaDisclaimer;
